import { clientCache } from '../universal';

const COLLECTION_KEY = 'texts';

const getCollectionKey = keys => `${keys.join('.')}.${COLLECTION_KEY}`;

export const translations = {

  areValid: (languageId) =>{
    return clientCache.hasValid(getCollectionKey(languageId));
  },
  add: (languageId, texts, expires)=>{
    clientCache.setItem(getCollectionKey(languageId), texts, expires);
  },
  get: (languageId) => {
    return clientCache.getItem(getCollectionKey(languageId));
  },
  clear: ()=> {
    clientCache.clearBy(
      new RegExp(`\.${COLLECTION_KEY}\.?`)
    );
  }
};
